<template>
	<span class="badge-cod" v-if="isCodEnabled" v-tooltip="'Cash on delivery'">COD</span>
</template>

<script>
export default {
	name: 'BadgeCod',
	props: {
		isCodEnabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.badge-cod {
	font-size: 10px;
	font-weight: 600;
	color: #fff;
	background-color: #006DC7;
	border-radius: 10px 0 10px 0;
	padding: 1px 2px 1px 2px;
}
</style>
